import { AssignmentRuleInput } from './assignmentRuleInput';

export class NewAssignmentRulesInput {
  assignmentRules: AssignmentRuleInput[] = [];
}
